import React from 'react';

import { Pressable } from '@rbilabs/universal-components';
import { StyleSheet } from 'react-native';
import type { PressableStateCallbackType } from 'react-native';

import { Box } from 'components/ui';
import type { BoxProps } from 'components/ui';
import { getDesignToken, primitive, spacing } from 'styles/constants';
import { isWeb } from 'utils/environment';

import { BORDER_BOTTOM_VALUE } from './constants';

type ListItemStyleProps = {
  isHeader?: boolean;
};

type ListItemButtonProps = React.ComponentPropsWithoutRef<typeof Pressable> & ListItemStyleProps;

const getListItemButtonStyle = (
  isHeader: boolean | undefined,
  style: ListItemButtonProps['style']
) => {
  const baseStyle = [
    styles.listItem,
    styles.listItemBorder,
    styles.listItemButton,
    isHeader && styles.headerListItem,
  ];

  if (typeof style === 'function') {
    return (state: PressableStateCallbackType) => [...baseStyle, style(state)];
  }

  return [...baseStyle, style];
};

export const ListItemContent = ({ isHeader, style, ...props }: BoxProps & ListItemStyleProps) =>
  React.createElement(Box, {
    ...props,
    style: [
      styles.listItem,
      styles.listItemBorder,
      isHeader && styles.headerListItem,
      isWeb && styles.webListItemContent,
      style,
    ],
  });

export const ListItemButton = ({ isHeader, style, ...props }: ListItemButtonProps) =>
  React.createElement(Pressable, {
    ...props,
    style: getListItemButtonStyle(isHeader, style),
  });

export const ProductControl = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, {
    ...props,
    style: [styles.productControl, style],
  });

const styles = StyleSheet.create({
  headerListItem: {
    backgroundColor: primitive.$mayoEggWhite,
  },
  listItem: {
    alignItems: 'center',
    backgroundColor: getDesignToken('background-pattern'),
    color: getDesignToken('text-default'),
    flexDirection: 'row',
    flexGrow: 1,
    justifyContent: 'space-between',
    paddingHorizontal: spacing.$4,
    paddingVertical: spacing.$4,
  },
  listItemBorder: {
    borderBottomColor: getDesignToken('border-color-default'),
    borderBottomWidth: BORDER_BOTTOM_VALUE,
  },
  listItemButton: {
    flexShrink: 1,
  },
  productControl: {
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginLeft: spacing.$2,
  },
  webListItemContent: {
    flex: 1,
  },
});
